import { ConditionChangeFTE } from './condition-change-fte';
import { CountyAssignment } from './county-assignment';
import { FTE, PPEProject } from '.';
import { ConditionChange } from '../condition-change';

export class FTEOverview {
	constructor(
		public readonly conditionChange: ConditionChangeFTE[],
		public readonly county: CountyAssignment[],
		public readonly projects: PPEProject[]) { }

	public static fromJson(o: any): FTEOverview {
		return new FTEOverview(
			ConditionChangeFTE.fromJson(o.conditionChange),
		   	o.county.map(CountyAssignment.fromJson),
		   	o.projects.map(PPEProject.fromJson));
	}

	public getConditionChangeGroupedByProgramArea(): ConditionChangeFTE[] {
		
		return this.conditionChange.map(item => {
			
			let totalFTEValue = 0;

			for (const fte of item.pairs.values()) {
				totalFTEValue += fte.value;
			}

			const newPairs = new Map<ConditionChange, FTE>();
			newPairs.set(
				new ConditionChange(-1, "Aggregate", false),
				new FTE(totalFTEValue, 2)
			);			

			return {
				programArea: item.programArea,
				pairs: newPairs
			};
		});
	}
}